import { FC } from "react";
import { toast } from "react-toastify";
import { useAddVirtualPosMutation } from "@/lib/services/data-layer/core";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { numberSeparator } from "@/lib/helper";
import { Button } from "@/components/ui/button";
import { addVirtualPosResponse } from "@/lib/types/DTO/core";
import { addVirtualPosIPGValues } from "../_schema/add-virtual-pos-ipg.schema";

type verifySendLinkDrawerProps = {
  setVPosLinkData: (value?: addVirtualPosResponse) => void;
  verifyDialog?: addVirtualPosIPGValues;
  setVerifyDialog: () => void;
};

const VerifySendLinkDrawer: FC<verifySendLinkDrawerProps> = ({
  setVPosLinkData,
  verifyDialog,
  setVerifyDialog,
}) => {
  const shopId = localStorage.getItem("agent_shop_id");

  const { mutate, isPending } = useAddVirtualPosMutation();

  const onOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setVerifyDialog();
    }
  };

  const onSendVPosLink = () => {
    if (verifyDialog) {
      mutate(
        {
          ...verifyDialog,
          shopId: shopId ?? "",
          amount: Number(verifyDialog.amount),
        },
        {
          onSuccess(data) {
            setVPosLinkData(data);
            setVerifyDialog();
            toast.success("لینک با موفقیت ارسال شد");
          },
          onError(e) {
            toast.error(e.message);
          },
        }
      );
    }
  };

  return (
    <Drawer open={!!verifyDialog} onOpenChange={onOpenChange}>
      <DrawerContent className="pb-[23px]">
        <div className="mx-auto w-full max-w-lg">
          <div className="p-[20px] pb-[0px] pt-[10px]">
            <DrawerHeader className="text-right border-b pb-[14.5px]">
              <DrawerTitle className="text-center font-normal px-[10px]">
               آیا اطلاعات تراکنش زیر مورد تأیید شماست؟
              </DrawerTitle>
              <DrawerDescription className="hidden"></DrawerDescription>
            </DrawerHeader>
            <div className="mt-[24px] mb-[28px] flex flex-col items-center justify-center">
              <p className="mb-[8px] text-base">شماره موبایل:</p>
              <p className="font-semibold text-xl">{verifyDialog?.mobile}</p>
              <p className="mt-[18px] mb-[8px] text-base">مبلغ قابل پرداخت:</p>
              <p className="font-bold text-xl">
                {numberSeparator({
                  value: verifyDialog?.amount ?? " ",
                  type: "money",
                })}
                <span className="text-[12px]">ریال</span>
              </p>
              {verifyDialog?.fullName && (
                <>
                  <p className="mt-[18px] mb-[8px] text-base">نام نام خانوادگی:</p>
                  <p className="font-medium text-xl">{verifyDialog?.fullName}</p>
                </>
              )}
            </div>
          </div>
          <div className="mx-auto w-[calc(100%-30px)]">
            <Button
              onClick={onSendVPosLink}
              disabled={isPending}
              className="w-full rounded-2xl"
            >
              {isPending ? "در حال ارسال..." : "هم اکنون لینک ارسال شود"}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default VerifySendLinkDrawer;
